// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tag[data-v-0458f0ae]{border-radius:var(--border-radius);color:var(--tag-primary);background-color:var(--tag-bg);padding:4px 6px 3px 6px;font-size:12px}", ""]);
// Exports
module.exports = exports;
